import { ApolloError } from "@apollo/client";

/**
 * Checks if an error is an authorization/permission error
 */
export function isAuthorizationError(error: unknown): boolean {
  if (!error) return false;

  if (error instanceof ApolloError) {
    // Check GraphQL errors for FORBIDDEN code
    if (
      error.graphQLErrors?.some((err) => err.extensions?.code === "FORBIDDEN")
    ) {
      return true;
    }
  }

  return false;
}
